import withHelmet from '../HOC/withHelmet';
import GiftCard from '../components/giftcard';

export default withHelmet(GiftCard, 'Give the gift of reading');
